import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TagsInput from 'react-tagsinput';
import AutosizeInput from 'react-input-autosize';
import { emailRegex, emailValidationMessage } from '../../../../formValidators';
import './AddCoworkersEmailInput.scss';

// Code snippet taken from https://github.com/olahol/react-tagsinput README
function autosizingRenderInput({ addTag, ...props }) {
  const { onChange, value, ...other } = props;
  return (
    <AutosizeInput
      inputClassName="invitation-email-input"
      type="text"
      onChange={onChange}
      value={value}
      {...other}
    />
  );
}

class AddCoworkersEmailInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: '',
    };

    this.handleEmailsChange = this.handleEmailsChange.bind(this);
    this.handleValidationReject = this.handleValidationReject.bind(this);
  }

  handleValidationReject(emails) {
    if (emails[0] !== '') {
      this.setState({ error: emailValidationMessage });
    }
  }

  handleEmailsChange(newEmails) {
    const { handleChange } = this.props;

    this.setState({ error: '' }, () => handleChange(newEmails));
  }

  render() {
    const { emails } = this.props;
    const { error } = this.state;

    return (
      <div className="add-coworkers-email-input-container">
        <TagsInput
          value={emails}
          onChange={(newEmails) => this.handleEmailsChange(newEmails)}
          addKeys={[9, 13, 32, 188, 186]} // space, enter, tab, etc
          tagProps={{
            className: 'invitation-email-tag',
            classNameRemove: 'react-tagsinput-remove',
          }}
          inputProps={{
            placeholder: emails.length > 0 ? '    ' : 'Type emails here',
          }}
          onValidationReject={this.handleValidationReject}
          validationRegex={emailRegex}
          onlyUnique
          renderInput={autosizingRenderInput}
          addOnBlur
        />
        { error
          && (
          <div className="error-text">
            { error }
          </div>
          )}
      </div>
    );
  }
}

AddCoworkersEmailInput.propTypes = {
  emails: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleChange: PropTypes.func,
};

AddCoworkersEmailInput.defaultProps = {
  handleChange: () => {},
};

export default AddCoworkersEmailInput;
